import { JSX } from 'react'

import { IconProps } from '../../icon'

const Search: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M38.8024 33.011L32.1087 26.3174C34.4383 21.576 33.6509 15.6534 29.697 11.716C24.7424 6.76134 16.6706 6.76134 11.716 11.716C6.76134 16.6706 6.76134 24.7424 11.716 29.697C14.1933 32.1743 17.4581 33.4212 20.7065 33.4212C22.626 33.4212 24.5455 32.9782 26.3174 32.1087L33.011 38.8024C33.7821 39.5734 34.8157 40 35.8985 40C36.9813 40 38.0149 39.5734 38.7859 38.8024C40.3773 37.211 40.3773 34.6188 38.7859 33.011H38.8024ZM13.455 27.958C9.45193 23.9549 9.45193 17.4581 13.455 13.455C15.4565 11.4535 18.0815 10.4527 20.7065 10.4527C23.3315 10.4527 25.9564 11.4535 27.958 13.455C31.961 17.4581 31.961 23.9549 27.958 27.958C23.9549 31.961 17.4581 31.961 13.455 27.958ZM37.0633 37.0633C36.4399 37.6867 35.3735 37.6867 34.7501 37.0633L28.4501 30.7634C28.8767 30.4353 29.2868 30.0907 29.6806 29.697C30.0743 29.3033 30.4189 28.8931 30.747 28.4665L37.0469 34.7665C37.6867 35.4063 37.6867 36.4399 37.0469 37.0797L37.0633 37.0633Z'
      fill='black'
    />
  </svg>
)

export default Search
